// extracted by mini-css-extract-plugin
export default {"table":"SimpleTable_table__jc1T7","tableStriped":"SimpleTable_tableStriped__jmLR7","active":"SimpleTable_active__RLSnC","tableHover":"SimpleTable_tableHover__Fzdut"};